import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SESSION_KEY = "pv_session";
const PROJECT_ID = "kdoqimkyctddzvuefakh";
const ENDPOINT = `https://${PROJECT_ID}.supabase.co/functions/v1/track-pageview`;
const ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtkb3FpbWt5Y3RkZHp2dWVmYWtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA2NTgxMDAsImV4cCI6MjA5NjIzNDEwMH0.FW--EIZq_brZ_Drpn1hRONsOlmgr9vCwuiUm8ILxSIA";

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export function usePageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    // Backend-Routen nicht tracken
    if (location.pathname.startsWith("/cms-backend") || location.pathname.startsWith("/hwm-backend")) {
      return;
    }
    let timer: number | undefined;
    let idleHandle: number | undefined;
    let loadListener: (() => void) | undefined;

    const send = () => {
      const body = JSON.stringify({
        path: location.pathname + location.search,
        referrer: document.referrer || null,
        session_id: getSessionId(),
      });
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", apikey: ANON_KEY, Authorization: `Bearer ${ANON_KEY}` },
        body,
        keepalive: true,
      }).catch(() => {});
    };

    const schedule = () => {
      timer = window.setTimeout(() => {
        const w = window as Window & {
          requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
          cancelIdleCallback?: (handle: number) => void;
        };
        if (typeof w.requestIdleCallback === "function") idleHandle = w.requestIdleCallback(send, { timeout: 5000 });
        else send();
      }, 8000);
    };

    if (document.readyState === "complete") schedule();
    else {
      loadListener = schedule;
      window.addEventListener("load", loadListener, { once: true });
    }

    return () => {
      if (timer) window.clearTimeout(timer);
      if (idleHandle) (window as Window & { cancelIdleCallback?: (handle: number) => void }).cancelIdleCallback?.(idleHandle);
      if (loadListener) window.removeEventListener("load", loadListener);
    };
  }, [location.pathname, location.search]);
}
